import { useUserRoleContext } from "../context/UserRoleContext";
import { ROLES, ROLE_GROUPS } from "./roles";

/**
 * useRoleCheck — returns role helpers scoped to a specific module.
 *
 * @param {string} moduleKey - Key of the module in userRole.moduli (e.g. "projekti", "razpisi")
 *
 * @returns {object}
 *   isLoading         - true while user role is being fetched
 *   isAdmin           - has GLOBALNI_ADMINISTRATOR role in the module
 *   isEditor          - has GLOBALNI_UREDNIK or GLOBALNI_ADMINISTRATOR
 *   isGlobalni        - has any globalni role (obiskovalec, urednik, administrator)
 *   isFakultetniSkrbnik - has FAKULTETNI_SKRBNIK role in the module
 *   isAll             - has any role in the module
 *   clanicaID         - the user's clanicaID (for fakultetni skrbnik scoping)
 *   hasRole(role)     - checks for a specific role string
 *   hasAnyRole(roles) - checks for any role in the given array
 */
const useRoleCheck = (moduleKey) => {
  const { userRole, isLoadingUserRole } = useUserRoleContext();

  const moduleRoles = userRole?.moduli?.[moduleKey] ?? [];

  const hasRole = (role) => moduleRoles.includes(role);
  const hasAnyRole = (roles) => roles.some((r) => moduleRoles.includes(r));

  return {
    isLoading: isLoadingUserRole,
    isAdmin: hasRole(ROLES.GLOBALNI_ADMINISTRATOR),
    isEditor: hasAnyRole(ROLE_GROUPS.EDITORS),
    isGlobalni: hasAnyRole(ROLE_GROUPS.GLOBALNI),
    isFakultetniSkrbnik: hasRole(ROLES.FAKULTETNI_SKRBNIK),
    isAll: hasAnyRole(ROLE_GROUPS.ALL),
    clanicaID: userRole?.clanicaID ?? null,
    hasRole,
    hasAnyRole,
  };
};

export default useRoleCheck;
